import { render, staticRenderFns } from "./threeSegmentCode.vue?vue&type=template&id=8751a796&scoped=true&"
import script from "./threeSegmentCode.vue?vue&type=script&lang=js&"
export * from "./threeSegmentCode.vue?vue&type=script&lang=js&"
import style0 from "./threeSegmentCode.vue?vue&type=style&index=0&id=8751a796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8751a796",
  null
  
)

export default component.exports